<template>
  <a-layout class="height-100">
    <img class="logo logo-center absolute top-0 left-0 m2" src="@/assets/logo.png" />
    <div class="height-100 mobile-card mobile-snap-bottom">
      <a-layout class="height-100">
        <a-layout-content>
          <a-row type="flex" justify="space-around" align="middle" class="height-100" >
            <a-col :span="24" :sm="16" :md="14" :lg="10" class="center">
              <h1 class="white left-align">Register</h1>
              <a-card class="card left-align">
                <a-form layout="vertical">
                  <a-form-item label="Email">
                    <a-input type="email" v-model="email" placeholder="Your email"></a-input>
                  </a-form-item>
                  <a-form-item label="Password">
                    <a-input type="password" v-model="password" placeholder="Your password"></a-input>
                  </a-form-item>
                  <a-form-item label="Repeat Password">
                    <a-input type="password" v-model="repeatPassword" placeholder="Your password again"></a-input>
                  </a-form-item>
                  <a-form-item class="mb0 left">
                    <small>Already have an account?  <a href="/login">Login.</a></small>
                  </a-form-item> 
                  <a-form-item class="mb0 right">
                    <a-button size="large" type="primary" :disabled="!isReady" :loading="loading" @click="onRegister">Register<a-icon type="right"/></a-button>
                  </a-form-item>
                </a-form>
              </a-card>
            </a-col>
          </a-row>
        </a-layout-content>
      </a-layout>
    </div>
  </a-layout>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      repeatPassword: '',
      loading: false
    }
  },
  computed: {
    isReady() {
      return this.email.length >= 4 && this.password.length >= 6 && this.password === this.repeatPassword
    }
  },
  methods: {
    onRegister() {
      this.loading = true;
      firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(({ user }) => {
        this.loading = false;
        this.$db.collection('users').doc(user.uid).set({
          email: user.email ,
          accessLevel: 'trainee',
          createdAt: Date.now()
        });
        this.$router.push('/register/personal-details');
      }).catch((err) => {
        this.loading = false;
        console.log('err!', err)
        this.$message.error('User already exists. Try login.');
      })
    }
  }
}
</script>
